import React from 'react';
import useOrganizationInvitationDefinitions from '../../../../hooks/api/useOrganizationInvitationDefinitions';
import { AnimateLoadedContent } from '../../../v2BaseComponents/Loader';
import DetailsContent from './DetailsContent';

export type InvitationDefinitionDetailsOwnProps = {
    invitationDefinitionId: string;
};

export type InvitationDefinitionDetailsProps = InvitationDefinitionDetailsOwnProps;

const InvitationDefinitionDetails: React.FC<InvitationDefinitionDetailsProps> = (props) => {
    const { isLoadingInvitationDefinition, invitationDefinition } = useOrganizationInvitationDefinitions({
        invitationDefinitionId: props.invitationDefinitionId,
    });

    return (
        <AnimateLoadedContent isLoading={isLoadingInvitationDefinition || !invitationDefinition}>
            {() => <DetailsContent invitationDefinition={invitationDefinition!} />}
        </AnimateLoadedContent>
    );
};

export default React.memo(InvitationDefinitionDetails);
